<template>
  <div>
    <Menu mode="horizontal" theme="dark">
      <div class="layout-logo">
        <img :src="vendorInfo.logo_url"/>
      </div>
      <div class="layout-nav">
      </div>
      <div class="layout-user">
        <MenuItem name="user-notification" to="/message">
          <Icon type="ios-notifications" style="font-size: 24px;color: white; float: left;line-height: 60px; height: 60px;"/>
        </MenuItem>
        <Submenu name="30">
          <template slot="title">
            <Icon type="person"></Icon>
            {{vendorInfo.name}}
          </template>
          <Menu-item name="30-1" @click.native="openUpdatePwdModal">修改密码</Menu-item>
          <Menu-item name="30-2" @click.native="onLogout">登出</Menu-item>
        </Submenu>

      </div>
    </Menu>
    <Modal
      v-model="showUpdatePwdModal"
      title="修改登录密码" :mask-closable="false"
      @on-ok="ok" :loading="loading"
      @on-cancel="showUpdatePwdModal = false">
      <Form ref="updateForm" :model="updateForm" :label-width="100" :rules="formRules">
        <Form-item label="老密码" prop="oldPwd">
          <Input v-model="updateForm.oldPwd" type="password" placeholder="请输入旧密码"></Input>
        </Form-item>
        <Form-item label="新密码" prop="newPwd1">
          <Input v-model="updateForm.newPwd1" type="password" placeholder="请输入新密码，至少8位"></Input>
        </Form-item>
        <Form-item label="新密码" prop="newPwd2">
          <Input v-model="updateForm.newPwd2" type="password" placeholder="请再次输入新密码"></Input>
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>
<script>
  import Util from '../libs/util';
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters([])
    },
    data() {
      return {
        vendorInfo: {
          company: ''
        },
        showUpdatePwdModal: false,
        loading: true,
        updateForm: {
          oldPwd: '',
          newPwd1: '',
          newPwd2: ''
        },
        formRules: {
          oldPwd: [
            {required: true, message: '请输入旧密码', trigger: 'blur'}
          ],
          newPwd1: [
            {required: true, message: '请输入新密码', trigger: 'blur'},
            {type: 'string', min: 8, message: '密码至少8位', trigger: 'blur'}
          ],
          newPwd2: [
            {required: true, message: '请输入再次输入新密码', trigger: 'blur'}
          ]
        },
      }
    },
    mounted() {
      this.$http.get('/vendor/myVendorInfo').then((resp) => {
        if (resp.status == 1) {
          this.vendorInfo = resp.data;
          this.$store.commit('updateState', {name:'myVendorInfo', value:this.vendorInfo});
        }
      });
    },
    methods: {
      onLogout() {
        Util.setToken("");
        this.$router.replace("login");
      },
      openUpdatePwdModal() {
        this.showUpdatePwdModal = true;
      },
      ok() {
        this.loading = true;
        this.$refs['updateForm'].validate((valid) => {
          if (this.updateForm.newPwd1 != this.updateForm.newPwd2) {
            this.loading = false;
            this.$Message.error("两次密码不一致");
            return false;
          }
          if (valid) {
            this.$http.post('/vendor/changePwd', this.updateForm).then((resp) => {
              this.loading = false;
              if (resp.status == 1) {
                this.$Message.success('密码更新成功!');
                this.$Modal.remove();
              } else {
                this.$Message.error(resp.message);
              }
            })
          } else {
            this.$Message.error('表单验证失败');
          }
        })
      }
    }
  };
</script>
<style>

</style>



// WEBPACK FOOTER //
// Header.vue?73826c30